import { doc, getDoc, updateDoc, setDoc, increment } from "firebase/firestore";
import { db } from "../config/firebase";

const COUNTER_DOC = doc(db, "omnicare_counters", "visitors");

/**
 * Get the current visitor count from Firestore.
 * Returns the count or null if unavailable.
 */
export async function getVisitorCount() {
  try {
    const snap = await getDoc(COUNTER_DOC);
    if (snap.exists()) {
      return snap.data().count || 0;
    }
    // Initialize if doesn't exist
    await setDoc(COUNTER_DOC, { count: 2000 });
    return 2000;
  } catch (err) {
    console.warn("Visitor counter read failed:", err);
    return null;
  }
}

/**
 * Increment the visitor count by 1 (call once per unique session).
 * Uses sessionStorage to dedupe within the same browser session.
 */
export async function incrementVisitorCount() {
  const KEY = "omnicare_counted";
  if (sessionStorage.getItem(KEY)) return; // already counted this session

  try {
    await updateDoc(COUNTER_DOC, { count: increment(1) });
    sessionStorage.setItem(KEY, "1");
  } catch (err) {
    // Doc might not exist yet — create it
    try {
      await setDoc(COUNTER_DOC, { count: 2001 });
      sessionStorage.setItem(KEY, "1");
    } catch (e) {
      console.warn("Visitor counter write failed:", e);
    }
  }
}
